// This file was once generated when you created this area
// but you can edit it freely

const baseRoute = '/capacity-planning'

export const CapacityPlanningAreaRoutes = {
  route: baseRoute,
  path: '/',
}
